import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';
import { Goal , GoalState , updateGoal } from './goalType';

export const createGoal = createAsyncThunk(
    'performance/createGoal',
    async (data: Goal, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/performance/goal', data);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create Goal');
      }
    }
  ); 

  export const UpdateGoal = createAsyncThunk<any , {goalId: number; data: any}, { rejectValue: string }>(
      'performance/updateGoal',
      async ({goalId, data}: {goalId: Number; data: Partial<updateGoal>}, { rejectWithValue }) => {
        try {  
          const response = await employeeServiceApiInstance.put(`/performance/goal/${goalId}`, data)
          return response.data;
        } catch (error: any) {
          return rejectWithValue(error.response?.data || 'Failed to create Goallist');
        }
      }
    ); 


    export const deleteGoal = createAsyncThunk(
        'performance/deleteGoal',
        async (goalId: number, { rejectWithValue }) => {
            try {
                const response = await employeeServiceApiInstance.delete(`/performance/goal/${goalId}`);
                return response.data;
            } catch (error: any) {
                return rejectWithValue(error.response?.data || 'Failed to delete Goal');
            }
        }
    );

    
export const fetchGoalById = createAsyncThunk(
    'performance/fetchGoalById',
    async (goalId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/performance/goal/${goalId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Goal');
        }
    }
);

export const fetchProfessionalGoalLastById = createAsyncThunk(
  'performance/fetchGoalById',
  async ({Id} : any, { rejectWithValue }) => {
      try {
          const response = await employeeServiceApiInstance.get(`/performance/professionalgoallast/${Id}`);
          return response.data;
      } catch (error: any) {
          return rejectWithValue(error.response?.data || 'Failed to fetch Goal');
      }
  }
);
export const fetchProfessionalGoalCurrentById = createAsyncThunk(
  'performance/fetchGoalById',
  async ({Id} : any, { rejectWithValue }) => {
      try {
          const response = await employeeServiceApiInstance.get(`/performance/professionalgoalcurrent/${Id}`);
          return response.data;
      } catch (error: any) {
          return rejectWithValue(error.response?.data || 'Failed to fetch Goal');
      }
  }
);

export const fetchAllGoal = createAsyncThunk(
    'performance/fetchAllGoal',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/performance/goal');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Goal');
        }
    }
);